var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpVerifiedProfile = function SvgUpVerifiedProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.103 13.356a10.092 10.092 0 0 1-2.413 3.765 12.622 12.622 0 0 1-4.714 2.8 1.441 1.441 0 0 1-.459.08h-.016a1.462 1.462 0 0 1-.476-.082 12.622 12.622 0 0 1-4.72-2.8 10.073 10.073 0 0 1-2.407-3.76A21.717 21.717 0 0 1 .02 5.447v-.036c.009-.194.015-.4.018-.622a2.122 2.122 0 0 1 1.996-2.077 8.203 8.203 0 0 0 5.59-2.36l.008-.01a1.277 1.277 0 0 1 1.736 0l.015.011a8.205 8.205 0 0 0 5.59 2.36 2.114 2.114 0 0 1 1.996 2.077c0 .226.01.43.018.622v.015a21.753 21.753 0 0 1-.884 7.93z",
    fill: "#3177F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.103 13.356a10.091 10.091 0 0 1-2.413 3.765 12.622 12.622 0 0 1-4.714 2.8 1.44 1.44 0 0 1-.458.081V-.004c.315.004.618.126.85.34l.013.012a8.205 8.205 0 0 0 5.59 2.36 2.115 2.115 0 0 1 1.996 2.077c0 .226.01.429.018.622v.019a21.755 21.755 0 0 1-.882 7.93z",
    fill: "#0B42F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.282 10a5.805 5.805 0 0 1-1.689 4.086 5.784 5.784 0 0 1-4.073 1.706H8.5a5.777 5.777 0 0 1-4.088-1.697 5.798 5.798 0 0 1 0-8.191A5.777 5.777 0 0 1 8.5 4.207h.02c1.53.007 2.994.62 4.074 1.706A5.805 5.805 0 0 1 14.282 10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.281 10a5.805 5.805 0 0 1-1.689 4.086 5.784 5.784 0 0 1-4.072 1.706V4.209c1.529.007 2.993.62 4.072 1.705A5.805 5.805 0 0 1 14.281 10z",
    fill: "#E0E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.478 8.989-2.942 2.949-.636.637a.769.769 0 0 1-1.088 0l-1.368-1.37a.772.772 0 0 1 .548-1.302c.2-.003.395.074.54.212l.824.825 3.035-3.041a.769.769 0 0 1 1.3.55.772.772 0 0 1-.212.54z",
    fill: "#2355FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v20H0z"
  })))));
};
export default SvgUpVerifiedProfile;